import Vue from '@triotech/vue-core/src/vendor/vue';
import vBlur from 'v-blur';

Vue.use(vBlur);
